import { BlobServiceClient, ContainerClient } from '@azure/storage-blob'
import { useOverlay } from '@pasteltech/overlay-provider'
import {
  useCreateBlobStorageContainer,
  useGetBlobDownloadUrl,
} from '@stewards-fas/queries'
import { useCallback } from 'react'

export function useBlobStorage() {
  const { showDialog } = useOverlay()

  const { mutateAsync: createBlobStorageContainer } =
    useCreateBlobStorageContainer()

  const { mutateAsync: getBlobDownloadUrl } = useGetBlobDownloadUrl()

  const handleGetBlobDownloadUrl = useCallback(
    async (id: string) => {
      const res = await getBlobDownloadUrl(id)
      if (res == null) {
        showDialog({
          title: 'title',
          content: 'content',
        })
        throw new Error('Failed to upload image')
      }
      return res
    },
    [getBlobDownloadUrl, showDialog],
  )

  const handleUpload = useCallback(
    async (file: File) => {
      try {
        const fileBuffer = await file.arrayBuffer()
        const containerInfo = await createBlobStorageContainer()
        const blobSasUrl = `${containerInfo.endpoint}${containerInfo.containerName}${containerInfo.sasToken}`

        const bloblServiceClient = new BlobServiceClient(blobSasUrl)

        const containerClient = new ContainerClient(blobSasUrl)
        bloblServiceClient.getContainerClient(containerInfo.containerName)

        const blockBlobClient = containerClient.getBlockBlobClient(file.name)

        await blockBlobClient.uploadData(fileBuffer)
        const urlWithSasToken = blockBlobClient.url
        return urlWithSasToken
      } catch (error) {
        if (error instanceof Error) {
          throw error
        }
        throw new Error(`Upload failed: ${String(error)}`)
      }
    },
    [createBlobStorageContainer],
  )

  const getDownloadUrl = useCallback(
    async (id: string) => {
      const res = await handleGetBlobDownloadUrl(id)
      return res.url
    },
    [handleGetBlobDownloadUrl],
  )

  return { getDownloadUrl, handleUpload }
}
